import Box from "@mui/material/Box";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { DiagnosticOverviewData } from "@/models/DiagnosticOverviewData";

export function NameCell(props: GridRenderCellParams<DiagnosticOverviewData>) {
  return (
    <Box
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {props.formattedValue || "---"}
    </Box>
  );
}
